<template>
  <div />
</template>

<script>
import User from '@/orm/models/User/User';

export default {
  name: 'RabotaRuAuth',
  async mounted() {
    const token = this.$route.query.access_token;
    if (!token) {
      return;
    }
    await User.api().loginByToken(token, true);
    await this.$router.push({ name: 'dashboard' });
  },
};
</script>

<style scoped>

</style>
